// extracted by mini-css-extract-plugin
module.exports = {"favorite":"favorite","favoriteBalloonNoticeWrapper":"favoriteBalloonNoticeWrapper"};